export const createWalks_sv = {
  'create' : 'Skapa',
  'create_start' : 'Start',
  'create_length' : 'Längd',
  'title' : 'Titel',
  'walk' : 'Promenad',
  'description' : 'Beskrivning',
  'position' : 'Plats',
  'choose_position' : 'Välj plats',
  'private_question' : 'Privat?',
  'category' : 'Kategori',
  'category_distance' : 'Distans',
  'category_meeting' : 'Möte',
  'category_lunch' : 'Lunchmöte',
  'category_morning': 'Morgonpromenad',
  'category_fika' : 'Fikapromenad',
  'category_problem' : 'Problemlösning',
  'category_50' : '50/50 promenad',
  'category_series' : 'Seriepromenad',
  'category_one' : '1:1',
  'repeat_walk' : 'Repetera promenaden',
  'each' : 'Varje',
  'number_of' : 'Antal',
  'every_month' : 'månad (var 4e vecka)',
  'private_information_header' : 'Info privat promenad',
  'private_information_message' : 'En privat promenad syns endast i din profil och för den du delar länken med.',
  'createWalk_error_message' : 'Var vänlig kontrollera din promenads information.',
  'teams_information_header' : 'Info team-promenad',
  'teams_information_message' : 'En team-promenad är endast synlig för personer som är registrerade medlemmar i samma team.',
  'repeat_information_header' : 'Info seriepromenad',
  'repeat_information_message' : 'En seriepromenad repeterar efter antal och interval. Bra att använda när du t.ex planerar eller repeterar en promenad ofta.',
  'mark_place' : 'Markera plats',
  'move_marker' : 'Flytta kartan tills markören är där promenaden startar',
  'position_description' : 'Beskrivning av platsen',
  'place' : 'Plats',

  'city' : 'Stad/Plats',
  'city_not_found' : 'Kunde inte hitta stadens namn',
  'city_not_found_tip' : 'Tips: Stämmer inte, eller kunde staden inte hittas kan du fylla i en egen text.',
  'walks_created' : 'Promenader som skapas:',
  'create_walk' : 'Skapa',
  'save_walk' : 'Spara Promenad',
  'delete_walk' : 'Ta bort promenad',

  'created' : 'skapad',
  'copy_walk' : 'Kopiera promenad',
  'change_walk' : 'Ändra promenad',
  'changed' : 'ändrad',
  'gps_error_map' : 'Du verkar ha stängt av gps-position. Googla "enable geolocation" för din browser om du vill slå på den. Du får börja på söder...',
  'available_to' :'Tillgänlig för',
  'your_walk_has' : 'Nu är din promenad ',
  'bookable_until' : 'Den kommer vara bokningsbar fram till',
  'go_to_walk' : 'Gå till promenaden',
  'add_to_cal_question' : 'Lägg till i kalender?',
  'added_to_cal' : 'Tillagd i kalender',
  'remove_walk_confirmation' : 'Är du säker på att du vill ta bort denna promenad?',
  'choose_team' : 'Välj team',

  'walk_length' : 'Promenadens längd'
}